<template>
  <div class="scroll-to-top" :class="{ 'scroll-to-top-mobile': isMobile }">
    <v-btn @click="scrollToTop" :class="{ active: isShowScrollBtn }" fab dark color="primary">
      <v-icon dark>keyboard_arrow_up</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkScrollTimeout: undefined,
      isShowScrollBtn: false
    }
  },
  methods: {
    watchScroll() {
      const scrollEventName = 'scroll' // this.isMobile ? 'scroll' : 'wheel'
      window.addEventListener(scrollEventName, this.onScroll, {
        capture: true,
        passive: true
      })
    },
    onScroll() {
      if (this.checkScrollTimeout) clearTimeout(this.checkScrollTimeout)
      this.checkScrollTimeout = setTimeout(() => {
        if (window.scrollY < 200) {
          this.isShowScrollBtn = false
        } else if (!this.isShowScrollBtn) this.isShowScrollBtn = true
        // console.log('watchScroll', window.scrollY)
      }, 100)
    },
    unwatchScroll() {
      const scrollEventName = 'scroll' // this.isMobile ? 'scroll' : 'wheel'
      window.removeEventListener(scrollEventName, this.onScroll, {
        capture: true,
        passive: true
      })
    },
    scrollToTop() {
      window.scrollTo({
        behavior: 'smooth',
        top: 0
      })
    }
  },
  mounted() {
    this.watchScroll()
  },
  destroyed() {
    this.unwatchScroll()
  }
}
</script>
<style lang="scss" scoped>
.scroll-to-top {
  position: fixed;
  bottom: 3rem;
  right: 0;

  button {
    transform: scale(0, 0);
    transition: all 0.2s;
    // will-change: scale;
    &.active {
      transform: scale(1, 1);
    }
  }

  i {
    line-height: 56px;
  }
}

.scroll-to-top-mobile {
  bottom: 0.5rem;
  right: 0.5rem;

  button {
    width: 36px;
    height: 36px;
  }

  i {
    line-height: 36px;
  }
}
</style>
